var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "SidebarShell",
    {
      attrs: {
        collapsed: _vm.collapsed,
        mobile: _vm.mobile,
        open: _vm.open,
        "accent-top": "",
        "accent-color": _vm.accentColor
      },
      on: {
        toggle: function($event) {
          return _vm.$emit("toggle")
        }
      },
      scopedSlots: _vm._u([
        {
          key: "brand",
          fn: function() {
            return [
              _c(
                "button",
                {
                  staticClass: "cliente-sidebar__back",
                  class: { "cliente-sidebar__back--collapsed": _vm.collapsed },
                  attrs: { type: "button", title: "Voltar para gestão" },
                  on: { click: _vm.back }
                },
                [
                  _c("icon-svg", {
                    staticClass: "cliente-sidebar__back-arrow",
                    attrs: {
                      name: "arrow-left",
                      size: _vm.BACK_ICON_SIZE,
                      color: "primary"
                    }
                  }),
                  !_vm.collapsed
                    ? _c("span", [_vm._v("Voltar para gestão")])
                    : _vm._e()
                ],
                1
              ),
              _c("ClientSwitcher", {
                attrs: { collapsed: _vm.collapsed },
                on: {
                  picked: function($event) {
                    return _vm.$emit("picked", $event)
                  },
                  "open-all": function($event) {
                    return _vm.$emit("open-all")
                  }
                }
              }),
              _c("JourneySidebarNext", { attrs: { collapsed: _vm.collapsed } })
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._l(_vm.groups, function(group) {
        return _c(
          "NavGroup",
          {
            key: group.title,
            attrs: { title: group.title, collapsed: _vm.collapsed }
          },
          _vm._l(group.items, function(item) {
            return _c("NavItem", {
              key: item.key,
              attrs: {
                item: item,
                subitems: item.subitems,
                collapsed: _vm.collapsed,
                mobile: _vm.mobile,
                active: _vm.isActive(item.routeName)
              },
              on: {
                click: function($event) {
                  return _vm.$emit("select", item)
                },
                "hover-subitems": _vm.openFlyout,
                "leave-subitems": _vm.scheduleClose
              }
            })
          }),
          1
        )
      }),
      _c(
        "transition",
        { attrs: { name: "flyout" } },
        [
          _vm.flyout
            ? _c("NavFlyout", {
                attrs: {
                  title: _vm.flyout.item.label,
                  items: _vm.flyout.item.subitems,
                  "anchor-top": _vm.flyout.top,
                  "anchor-left": _vm.flyout.left,
                  "active-route-name": _vm.activeRouteName
                },
                on: {
                  select: _vm.onSelectSubitem,
                  mouseenter: _vm.cancelClose,
                  mouseleave: _vm.scheduleClose
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }